import { render, staticRenderFns } from "./LogoSketchIcon.vue?vue&type=template&id=711e2414&"
import script from "./LogoSketchIcon.vue?vue&type=script&lang=js&"
export * from "./LogoSketchIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports